var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dicom-page"},[_c('div',{staticClass:"dicom-card"},[_c('h1',{staticClass:"dicom-title"},[_vm._v(_vm._s(_vm.$t("nav.dicom_anonymize_download")))]),_c('a',{staticClass:"download-button",attrs:{"href":_vm.downloadUrl,"download":"","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("nav.dicom_anonymize_download"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }